var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "634.000000pt",
    height: "393.000000pt",
    viewBox: "0 0 634.000000 393.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,393.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3212 3102 c-25 -13 -112 -135 -382 -540 -193 -287 -350 -526 -350 -531 0 -4 174 -102 388 -216 213 -115 410 -221 437 -236 28 -15 196 -105 375 -201 179 -96 519 -279 755 -406 237 -127 439 -234 449 -238 11 -4 -71 127 -199 317 -120 178 -302 448 -403 599 -102 151 -263 390 -357 530 -94 140 -265 395 -380 565 -114 171 -219 322 -234 336 -36 37 -60 42 -99 21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856 2694 c-9 -8 -16 -30 -16 -48 0 -17 62 -188 138 -381 137 -344 248 -627 497 -1260 137 -347 152 -372 242 -415 42 -20 57 -20 1535 -20 1422 0 1495 1 1533 19 84 38 90 33 -238 206 -166 88 -356 189 -422 223 -110 58 -362 192 -590 312 -117 62 -412 217 -545 288 -58 30 -170 90 -250 132 -80 43 -192 102 -250 133 -212 111 -977 515 -1050 554 -41 22 -118 63 -170 90 -52 28 -152 80 -221 117 -129 68 -166 78 -193 50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5555 2697 c-11 -8 -90 -50 -175 -95 -437 -227 -1165 -613 -1172 -620 -6 -6 34 -76 98 -173 59 -90 153 -234 209 -319 56 -85 173 -263 259 -395 87 -132 163 -246 170 -253 13 -13 9 -24 190 443 58 149 148 380 201 515 53 135 114 290 135 345 21 55 73 187 114 293 42 106 76 204 76 216 0 47 -62 72 -105 43z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlit);
export default __webpack_public_path__ + "static/media/Streamlit.4eaf31eee1a6e2399f4e6d638a532937.svg";
export { ForwardRef as ReactComponent };